import { connect } from 'react-redux';
import {
    actions
} from '../../../../../../redux/modules/Reporte/reporteAumentoPrecios';
import AumentoProductoGrid from './ProductoGris';

const mstp = state => {
    return {...state.reporteAumentoPrecios,permisos: state.login.me.permisos, }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(AumentoProductoGrid)


